import React from 'react'
import styled from 'styled-components'
import FontAwesome from 'react-fontawesome'

export const TabsContainer = styled.div`
    padding: 20px;
`

export const TabsContentHeader = styled.div`
    position: relative;
    ${props => (props.margin ? `
        margin: ${props.margin};
    ` : '')}
`

export const TabsContentHeadline = styled.h2`
    color: var(--cyan);
    font-weight: 300;
    font-size: 1.6rem;
    ${props => (props.margin ? `
        margin: ${props.margin};
    ` : '')}
`

export const TabsContentToggleIcon = styled(({ isOpened, ...rest }) => <FontAwesome {...rest} />)`
    color: var(--cyan);
    position: absolute;
    right: 10px;
    top: 8px;
    ${props => (props.isOpened ? `
        transform: rotate(180deg);
    ` : '')}
`

export const TabsContent = styled.div`
    margin-bottom: 30px;
`

export const TabContentDescription = styled.div`

    margin: 15px 0;
    padding: 5px;
    
    h2 {
        font-size: 1.5rem;
        font-weight: 500;
        color: var(--cyan);
    }
    
    h3 {
        font-size: 1.2rem;
        font-weight: 500;
        color: var(--cyan);
    }
    
    p {
        font-weight: 300;
    }
    
    strong {
        // color: var(--cyan-complement-color);
    }
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Plants/PlantTabs.js